import {NgModule} from "@angular/core";
import {IntTableStylingComponent} from "./int-table-styling.component";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntTableStylingComponent
  ],
  exports: [
    IntTableStylingComponent
  ]
})
export class IntTableStylingModule {}
